module.exports = __webpack_public_path__ + "static/Infographic5-4946c8fd9864c9f6980cb9cd16971e97.png";